import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWaitingGroupsWithStudentsCount } from "../../../../redux/actions/reportActions";
import moment from "moment";
import "moment/locale/az";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useCustomHook } from "../../../../globalComponents/GlobalFunctions/globalFunctions";

const groupStatuses = [
  { key: "waiting", name: "Yığılan" },
  { key: "current", name: "Mövcud" },
  { key: "ended", name: "Bitmiş" },
];

const Groups = () => {
  const dispatch = useDispatch();
  const { waitinGroupsWithStudentsCount } = useSelector(
    (state) => state.reportDatas
  );
  const { studentStatus } = useCustomHook();
  const [selectedStudentStatus, setSelectedStudentStatus] = useState("all");
  const [selectedGroupStatus, setSelectedGroupStatus] = useState("all");
  const groupDateKey =
    selectedGroupStatus === "all" || selectedGroupStatus === "waiting"
      ? "createdAt"
      : selectedGroupStatus === "current"
      ? "startDate"
      : "endDate";

  useEffect(() => {
    dispatch(
      getWaitingGroupsWithStudentsCount(
        selectedGroupStatus === "all" ? "" : selectedGroupStatus,
        selectedStudentStatus === "all" ? "" : selectedStudentStatus
      )
    );
  }, [selectedGroupStatus, selectedStudentStatus, dispatch]);

  console.log(groupDateKey);
  return (
    <div className="report-groups">
      <Box display={"flex"} justifyContent={"space-between"} gap={2} mb={2}>
        <div className="group-header">
          <h2>Qruplar</h2>
        </div>
        <Box
          display={"flex"}
          justifyContent={"flex-start"}
          gap={2}
          width={"50%"}
        >
          <FormControl fullWidth sx={{ mb: 2, padding: 0 }}>
            <InputLabel id="demo-simple-select-label">Qrup statusu</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedGroupStatus}
              label="Qrup statusu"
              onChange={(e) => setSelectedGroupStatus(e.target.value)}
              sx={{ fontSize: 12 }}
            >
              <MenuItem value={"all"} sx={{ fontSize: 12 }}>
                Hamısı
              </MenuItem>
              {groupStatuses.map((status, i) => (
                <MenuItem key={i} value={status.key} sx={{ fontSize: 12 }}>
                  {status.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2, padding: 0 }}>
            <InputLabel id="demo-simple-select-label">
              Tələbə statusu
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedStudentStatus}
              label="Tələbə statusu"
              onChange={(e) => setSelectedStudentStatus(e.target.value)}
              sx={{ fontSize: 12 }}
            >
              <MenuItem value={"all"} sx={{ fontSize: 12 }}>
                Hamısı
              </MenuItem>
              {studentStatus.map((status, i) => (
                <MenuItem key={i} value={status.key} sx={{ fontSize: 12 }}>
                  {status.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <div className="group-cards">
        <p
          style={{
            fontSize: "14px",
            marginTop: "10px",
            fontWeight: "500",
          }}
        >
          {" "}
          {selectedGroupStatus === "all" || selectedGroupStatus === "waiting"
            ? "Yığılmağa başl. tarixi"
            : selectedGroupStatus === "current"
            ? "Dərsin başlama tarixi"
            : "Dərsin bitmə tarixi"}
        </p>

        <ul
          className="group-card"
          style={{
            backgroundColor: "lightgray",
            fontSize: "14px",
            visibility: "hidden",
          }}
        >
          <li style={{ justifySelf: "start" }}>Yığılma tarixi</li>
          <li style={{ justifySelf: "center" }}>Qrup adı</li>
          <li style={{ justifySelf: "end" }}>Tələbə sayı</li>
        </ul>
        {waitinGroupsWithStudentsCount?.map((group, i) => (
          <div key={i} className="group-card">
            <span style={{ justifySelf: "start" }}>
              {group[groupDateKey]
                ? moment(group[groupDateKey])
                    .locale("az")
                    .format("DD MMMM YYYY")
                : "---- ---- ----"}
            </span>
            <span style={{ justifySelf: "center" }}>{group.name}</span>
            <span style={{ justifySelf: "end" }}>
              {group.studentsCount} tələbə
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Groups;
